export const addNoIndexTag = () => {
  const tag = document.createElement("meta");
  tag.setAttribute("name", "robots");
  tag.setAttribute("content", "no-index");
  document.head.appendChild(tag);
};
